import CardStatus from "../../../components/card-status";
import {useApp} from "../../../hooks/use-app";
import Loading from "../../../components/loading";

export default function ListPlanning({
                                       account,
                                       event,
                                       listPlanning,
                                       updatePlanning,
                                       openCardId,
                                       setOpenCardId,
                                       handleRemovedUserFromPlanning,
                                       loadMore,
                                       callbackCardFinalized,
                                     }) {
  const { reachedTheLimitOfPlanning } = useApp()

  const getDisplayKey = (item) => (item.postCreditId && item.isPostCredit) ? `${item.id}${item.postCreditId}` : `${item.id}`;

  return !!listPlanning.results.length ? (
    <>
      {
        listPlanning.loading ? (
          <div className="wrapper-loading-small">
            <Loading small />
          </div>
        ) : null
      }
      {
        listPlanning?.results.map((item) => {
          const displayKey = getDisplayKey(item);

          return (
            <CardStatus
              key={displayKey}
              data={item}
              callbackFinalized={(e) => callbackCardFinalized(e)}
              isFinished={item.isFinished}
              showDuplicate={!reachedTheLimitOfPlanning}
              event={event}
              clickOptions={() => setOpenCardId((prev) =>
                prev === displayKey ? null : displayKey
              )}
              isOpen={openCardId === displayKey}
              onUserRemoved={handleRemovedUserFromPlanning}
              hideLoading={updatePlanning}
              isMonitoring={(item.isPostCredit && !!item.postCreditId)}
            />
          );
        })
      }
      {
        !!listPlanning?.next ? (
          <div className="more-planning">
            <button
              type="button"
              onClick={loadMore}
            >
              Carregar mais planejamentos
            </button>
          </div>
        ) : ''
      }
    </>
  ) : (
    <div className="empty">Nenhum resultado encontrado</div>
  )
}